import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Skeleton } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { PageHeader } from '@ant-design/pro-layout';
import { DefaultPageLayout } from 'layouts/default-page-layout';
import { useGetTransportCostPerKm } from 'api/transports/use-get-transport-cost-per-km';
import { useDirtySet } from 'shared/hooks/use-dirty-set';
import { CostsPerKmCreate } from 'components/costs/costs-per-km-create';
import { CostsPerKmList } from 'components/costs/costs-per-km-list';

export const CostsPerKmPage = () => {
  const { t } = useTranslation();
  const { data, isLoading } = useGetTransportCostPerKm();
  const [isEditing, setIsEditing] = useState(false);
  const { addDirty, removeDirty, clearDirty, hasDirty } = useDirtySet();

  const handleToggleEditing = () => {
    if (!isEditing) {
      setIsEditing(true);
      return;
    }

    if (hasDirty()) {
      if (!confirm(t('common:on_close_confirmation', { title: t('km-cost:costs_per_km') }))) return;
    }

    clearDirty();
    setIsEditing(false);
  };

  return (
    <DefaultPageLayout
      header={
        <PageHeader
          title={t('km-cost:costs_per_km')}
          extra={[
            <Button key='update-costs' icon={<EditOutlined />} onClick={handleToggleEditing}>
              {isEditing ? t('common:done') : t('km-cost:update_costs')}
            </Button>,
            <CostsPerKmCreate key='costs-per-km-create' />,
          ]}
        />
      }>
      {!isLoading ? (
        <CostsPerKmList
          transportKmCostData={data || []}
          isEditing={isEditing}
          addDirty={addDirty}
          removeDirty={removeDirty}
        />
      ) : (
        <Skeleton />
      )}
    </DefaultPageLayout>
  );
};
